export enum ComponentWidthEnum {
	FULLSCREEN = 'fullscreen',
	FIX_1200 = '1200px'
}
